import { inject, Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { CoreModule } from '../core.module';
import { HubLovService } from './hub-lov.service';

@Injectable({
    providedIn: CoreModule
})
export class OutcomeLovService {
    private hubLovService: HubLovService = inject(HubLovService);

    public getOutcomeLovs(): Observable<any> {
        return forkJoin({
            attributionLevels: this.hubLovService.getAttributionLevels(),
            scaMetrics: this.hubLovService.getOutcomeMetrics(),
            organizationalMetrics: this.hubLovService.getOutcomeMetrics()
        });
    }
}
